<template>
	<div>
        <div class="row">
            <div class="col-md-12">

                <el-form  class="mt-0" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <!-- clearable -->
                                <el-select v-model="year" filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                {{ this.lastUpdate }}
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row">
                    <div class="col-md-12">
                        <table class="app-table">
                            <tr>
                                <th rowspan="3" class="">Type</th>
                                <th rowspan="3" class="">Product</th>
                                <th colspan="4">Real {{ this.year}}</th>
                                <th colspan="4">Real {{ this.year - 1}}</th>
                                <th colspan="4">YoY {{ this.year }} vs {{ this.year - 1}} (%)</th>
                            </tr>
                            <tr>
                                <th>Vol Sales (L)</th>
                                <th>Vol Losses (L)</th>
                                <th class="top-red-border red-border">Losses Value (Rp)</th>
                                <th class="top-yellow-border yellow-border">% Losses</th>
                                <th>Vol Sales (L)</th>
                                <th>Vol Losses (L)</th>
                                <th class="top-red-border red-border">Losses Value (Rp)</th>
                                <th class="top-yellow-border yellow-border">% Losses</th>
                                <th>Vol Sales (L)</th>
                                <th>Vol Losses (L)</th>
                                <th class="top-red-border red-border">Losses Value (Rp)</th>
                                <th class="top-yellow-border yellow-border">% Losses</th>
                            </tr>
                            <tr>
                                <th :style="'width:'+columnValueWidth+'px;'">A</th>
                                <th :style="'width:'+columnValueWidth+'px;'">B</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="red-border">C</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="yellow-border">D</th>
                                <th :style="'width:'+columnValueWidth+'px;'">E</th>
                                <th :style="'width:'+columnValueWidth+'px;'">F</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="red-border">G</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="yellow-border">H</th>
                                <th :style="'width:'+columnValueWidth+'px;'">I=A:E</th>
                                <th :style="'width:'+columnValueWidth+'px;'">J=B:F</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="red-border">K=C:G</th>
                                <th :style="'width:'+columnValueWidth+'px;'" class="yellow-border">L=D:H</th>
                            </tr>
                            <tr></tr>
                            <tr v-for="item in pertashop" :key="item.StationType+item.ProductName">
                                <td class="" style="width:200px;">{{ item.StationType }}</td>
                                <td class="">{{ item.ProductName }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeSales) }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeLosses) }}</td>
                                <td class="text-right red-border">{{ formatNum(item.LosseValue) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(item.LossesPercentage) }}%</td>

                                <td class="text-right">{{ formatNum(item.VolumeSalesBefore) }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeLossesBefore) }}</td>
                                <td class="text-right red-border">{{ formatNum(item.LosseValueBefore) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(item.LossesPercentageBefore) }}%</td>

                                <td class="text-right">{{ formatNum((divideNum(item.VolumeSales/item.VolumeSalesBefore)) * 100) }}%</td>
                                <td class="text-right">{{ formatNum((divideNum(item.VolumeLosses/item.VolumeLossesBefore)) * 100) }}%</td>
                                <td class="text-right red-border">{{ formatNum((divideNum(item.LosseValue/item.LosseValueBefore)) * 100) }}%</td>
                                <td class="text-right yellow-border">{{ formatNum((divideNum(item.LossesPercentage/item.LossesPercentageBefore)) * 100) }}%</td>
                            </tr>
                            <tr class="sub-header-cell">
                                <td>PERTASHOP TOTAL</td>
                                <td></td>
                                <td class="text-right">{{ formatNum(this.reportData.pertashop_total[0].VolumeSales) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.pertashop_total[0].VolumeLosses) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.pertashop_total[0].LosseValue) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(this.reportData.pertashop_total[0].LossesPercentage) }}%</td>

                                <td class="text-right">{{ formatNum(this.reportData.pertashop_total[0].VolumeSalesBefore) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.pertashop_total[0].VolumeLossesBefore) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.pertashop_total[0].LosseValueBefore) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(this.reportData.pertashop_total[0].LossesPercentageBefore) }}%</td>

                                <td class="text-right">{{ formatNum((divideNum(this.reportData.pertashop_total[0].VolumeSales/this.reportData.pertashop_total[0].VolumeSalesBefore)) * 100) }}%</td>
                                <td class="text-right">{{ formatNum((divideNum(this.reportData.pertashop_total[0].VolumeLosses/this.reportData.pertashop_total[0].VolumeLossesBefore)) * 100) }}%</td>
                                <td class="text-right red-border">{{ formatNum((divideNum(this.reportData.pertashop_total[0].LosseValue/this.reportData.pertashop_total[0].LosseValueBefore)) * 100) }}%</td>
                                <td class="text-right yellow-border">{{ formatNum((divideNum(this.reportData.pertashop_total[0].LossesPercentage/this.reportData.pertashop_total[0].LossesPercentageBefore)) * 100) }}%</td>
                            </tr>
                            <tr v-for="item in spbu" :key="item.StationType+item.ProductName">
                                <td>{{ item.StationType }}</td>
                                <td>{{ item.ProductName }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeSales) }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeLosses) }}</td>
                                <td class="text-right red-border">{{ formatNum(item.LosseValue) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(item.LossesPercentage) }}%</td>

                                <td class="text-right">{{ formatNum(item.VolumeSalesBefore) }}</td>
                                <td class="text-right">{{ formatNum(item.VolumeLossesBefore) }}</td>
                                <td class="text-right red-border">{{ formatNum(item.LosseValueBefore) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(item.LossesPercentageBefore) }}%</td>

                                <td class="text-right">{{ formatNum((divideNum(item.VolumeSales/item.VolumeSalesBefore)) * 100) }}%</td>
                                <td class="text-right">{{ formatNum((divideNum(item.VolumeLosses/item.VolumeLossesBefore)) * 100) }}%</td>
                                <td class="text-right red-border">{{ formatNum((divideNum(item.LosseValue/item.LosseValueBefore)) * 100) }}%</td>
                                <td class="text-right yellow-border">{{ formatNum((divideNum(item.LossesPercentage/item.LossesPercentageBefore)) * 100) }}%</td>
                            </tr>
                            <tr class="sub-header-cell">
                                <td>SPBU TOTAL</td>
                                <td></td>
                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeSales) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeLosses) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.spbu_total[0].LosseValue) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(this.reportData.spbu_total[0].LossesPercentage) }}%</td>

                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeSalesBefore) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeLossesBefore) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.spbu_total[0].LosseValueBefore) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(this.reportData.spbu_total[0].LossesPercentageBefore) }}%</td>

                                <td class="text-right">{{ formatNum((divideNum(this.reportData.spbu_total[0].VolumeSales/this.reportData.spbu_total[0].VolumeSalesBefore)) * 100) }}%</td>
                                <td class="text-right">{{ formatNum((divideNum(this.reportData.spbu_total[0].VolumeLosses/this.reportData.spbu_total[0].VolumeLossesBefore)) * 100) }}%</td>
                                <td class="text-right red-border">{{ formatNum((divideNum(this.reportData.spbu_total[0].LosseValue/this.reportData.spbu_total[0].LosseValueBefore)) * 100) }}%</td>
                                <td class="text-right yellow-border">{{ formatNum((divideNum(this.reportData.spbu_total[0].LossesPercentage/this.reportData.spbu_total[0].LossesPercentageBefore)) * 100) }}%</td>
                            </tr>
                            <tr class="sub-header-cell2">
                                <td>GRAND TOTAL</td>
                                <td></td>
                                <td class="text-right">{{ formatNum((this.reportData.spbu_total[0].VolumeSales) + (this.reportData.pertashop_total[0].VolumeSales)) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.spbu_total[0].LosseValue+this.reportData.pertashop_total[0].LosseValue) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum((this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses)/((this.reportData.spbu_total[0].VolumeSales) + (this.reportData.pertashop_total[0].VolumeSales)) * 100)) }}%</td>

                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeSalesBefore+this.reportData.pertashop_total[0].VolumeSalesBefore) }}</td>
                                <td class="text-right">{{ formatNum(this.reportData.spbu_total[0].VolumeLossesBefore+this.reportData.pertashop_total[0].VolumeLossesBefore) }}</td>
                                <td class="text-right red-border">{{ formatNum(this.reportData.spbu_total[0].LosseValueBefore+this.reportData.pertashop_total[0].LosseValueBefore) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum( (this.reportData.spbu_total[0].VolumeLossesBefore+this.reportData.pertashop_total[0].VolumeLossesBefore) / (this.reportData.spbu_total[0].VolumeSalesBefore+this.reportData.pertashop_total[0].VolumeSalesBefore)) * 100 ) }}%</td>

                                <td class="text-right">{{ formatNum((divideNum((this.reportData.spbu_total[0].VolumeSales+this.reportData.pertashop_total[0].VolumeSales)/(this.reportData.spbu_total[0].VolumeSalesBefore+this.reportData.pertashop_total[0].VolumeSalesBefore))) * 100) }}%</td>
                                <td class="text-right">{{ formatNum((divideNum((this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses)/(this.reportData.spbu_total[0].VolumeLossesBefore+this.reportData.pertashop_total[0].VolumeLossesBefore))) * 100) }}%</td>
                                <td class="text-right red-border">{{ formatNum((divideNum((this.reportData.spbu_total[0].LosseValue+this.reportData.pertashop_total[0].LosseValue)/(this.reportData.spbu_total[0].LosseValueBefore+this.reportData.pertashop_total[0].LosseValueBefore))) * 100) }}%</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum(((this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses)/(this.reportData.spbu_total[0].VolumeLossesBefore+this.reportData.pertashop_total[0].VolumeLossesBefore))/((this.reportData.spbu_total[0].VolumeSales+this.reportData.pertashop_total[0].VolumeSales)/(this.reportData.spbu_total[0].VolumeSalesBefore+this.reportData.pertashop_total[0].VolumeSalesBefore))) * 100 ) }}%</td>
                            </tr>
                        </table>

                        <Loader v-if="loading.table"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 text-right">
                        <i>*exclude KSO TAC&nbsp;</i>
                    </div>
                </div>

                <!-- :span-method="objectSpanMethod" -->
                <!--
                <el-table
                    :data="tableData"
                    
                    stripe
                    border
                    style="width: 100%; font-size:12px;"
                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                    :header-row-style="{padding:'0px'}"
                    :cell-style="{padding: '8px 0px'}"   
                    class="mt-1">

                    <el-table-column
                        fixed
                        prop="type"
                        label="Type"
                        header-align="center"
                        width="120">
                    </el-table-column>

                    <el-table-column
                        fixed
                        prop="product"
                        label="Product"
                        header-align="center"
                        width="160">
                    </el-table-column>

                    <el-table-column
                        label="Real 2023"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_vol_sales"
                                label="A"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_vol_losses"
                                label="B"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_losses_value"
                                label="C"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_losses_percentage"
                                label="D"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                    <el-table-column
                        label="Real 2022"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_vol_sales"
                                label="E"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_vol_losses"
                                label="F"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_losses_value"
                                label="G"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_losses_percentage"
                                label="H"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                    <el-table-column
                        label="YoY 2023 vs 2022 (%)"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_sales"
                                label="I=A:E"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses"
                                label="J=B:F"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses_value"
                                label="K=C:G"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses_percentage"
                                label="L=D:H"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                </el-table>
            -->
                <div class="p-3 mt-2">
                    <div class="pl-2 pr-3" style="color:#1D7BBB;border: 1px solid #1D7BBB;border-style: dashed;border-radius:10px;background:#F5F5F5;">
                        <ul class="pt-3">
                            <li><b>Volume Losses Pertashop</b> Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} sebesar <b>{{ formatNum(divideNum(this.reportData.pertashop_total[0].VolumeLosses/1000)) }} KL</b> atau <b>{{ formatNum(this.reportData.pertashop_total[0].LossesPercentage) }}%</b> dari volume penjualan Pertashop.</li>
                            <li><b>Volume Losses SPBU</b> Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} sebesar <b>{{ formatNum(divideNum(this.reportData.spbu_total[0].VolumeLosses)/1000) }} KL</b> atau <b>{{ formatNum(this.reportData.spbu_total[0].LossesPercentage) }}%</b> dari volume penjualan SPBU.</li>
                            <li><b>Volume Losses Konsolidasi</b> Ytd {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year}} sebesar <b>{{ formatNum(divideNum( (this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses))/1000) }} KL</b> atau <b>{{ formatNum(divideNum((this.reportData.spbu_total[0].VolumeLosses+this.reportData.pertashop_total[0].VolumeLosses)/((this.reportData.spbu_total[0].VolumeSales) + (this.reportData.pertashop_total[0].VolumeSales)) * 100)) }}%</b>.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import {Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            columnValueWidth : 100,

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            loading: {
                table: false,
            },
            tableData: [],
            reportData:{
                pertashop_total: [
                    {
                        StationType: "PERTASHOP",
                        VolumeSales: 0,
                        VolumeLosses: 0,
                        LosseValue: 0,
                        LossesPercentage: 0,
                        VolumeSalesBefore: 0,
                        VolumeLossesBefore: 0,
                        LosseValueBefore: 0,
                        LossesPercentageBefore: 0,
                    }
                ],
                spbu_total: [
                    {
                        StationType: "SPBU",
                        VolumeSales: 0,
                        VolumeLosses: 0,
                        LosseValue: 0,
                        LossesPercentage: 0,
                        VolumeSalesBefore: 0,
                        VolumeLossesBefore: 0,
                        LosseValueBefore: 0,
                        LossesPercentageBefore: 0,
                    }
                ]
            },
            /*
            tableData: [
                {
                    type: 'Pertashop',
                    product: 'DEXLITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'Pertashop',
                    product: 'PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'Pertashop Total',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO SOLAR',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO SOLAR INDUSTRI',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'DEXLITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTALITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTALITE KHUSUS',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERATAMAX RACING',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMINA TURBO',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMINA DEX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PREMIUM',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'VIGAS',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU TOTAL',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'GRAND TOTAL',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
            ]
            */
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
        this.resumePilihan()
    },
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return { rowspan: 2, colspan: 1 };
          } else if (rowIndex === 3) {
            return { rowspan: 12, colspan: 1 };
          } 
        }
      },
      resumePilihan() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/losses-by-product?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportData = response.data;
                this.tableData = response.data.data;
                this.lastUpdate = this.reportData.last_update
                //console.log('pertashop data: ' + JSON.stringify(this.reportData.pertashop_total))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        setDefaultPeriod() {
            // Mengecek apakah kunci 'username' sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },
        applyFilter() {
            this.resumePilihan()
        },
    },

    computed: {
        pertashop() {
            // Define your filter condition here
            const filterCondition = item => item.StationType === 'PERTASHOP'; // Change this condition as needed
            
            // Apply the filter to the items array and return the filtered result
            return this.tableData.filter(filterCondition);
        },
        spbu() {
            // Define your filter condition here
            const filterCondition = item => item.StationType === 'SPBU'; // Change this condition as needed
            
            // Apply the filter to the items array and return the filtered result
            return this.tableData.filter(filterCondition);
        }
    },
}
</script>

<style scoped>
table {
    display: block;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin: 0 auto;
    overflow-x: auto;
    white-space: nowrap;
}

.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  border-radius:4px;
  width: 100% !important;
  overflow-x: auto; 
}
 
.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #e0f3ff/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color: rgba(66, 161, 255, 0.26) /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #409EFF/*#0070C0*/;
  color: white;
}

.sub-header-cell {
    background-color: rgba(66, 161, 255, 0.46) /* #8EA9DB*/;
    font-weight:bold;
    color:#000;
}

.sub-header-cell2 {
    background-color: #409EFF /* #8EA9DB*/;
    font-weight:bold;
    color:#000;
}
.red-border {
    border-left:3px solid #F56C6C !important;
    border-right:3px solid #F56C6C !important;
}

.yellow-border {
    border-left:3px solid #E6A23C !important;
    border-right:3px solid #E6A23C !important;
}

.top-red-border {
    border-top:3px solid #F56C6C !important;
}
.bottom-red-border {
    border-bottom:3px solid #F56C6C !important;
}

.top-yellow-border {
    border-top:3px solid #E6A23C !important;
}

.bottom-yellow-border {
    border-bottom:3px solid #E6A23C !important;
}

/* Style the fixed columns */
.fixed-column {
    position: sticky;
    left: 0;
    /*background-color: #fff;*/
    z-index: 1;
  }

  /* Add some spacing for the fixed column */
  .fixed-column th, .fixed-column td {
    padding-left: 20px;
  }
</style>